<script>
import { pageNotFoundEmits, usePageNotFound } from "./mixin";
import LazyImage from "@/components/atoms/lazy-image";
import ButtonIcon from "@/components/molecules/button-icon";
import Container from "@/components/atoms/container";

import page404Animation from "@/assets/images/404-maintenance/page-404-animation.gif";
import panneauCora from "@/assets/images/404-maintenance/panneau-cora.svg";

export default {
  components: {
    LazyImage,
    ButtonIcon,
    Container
  },
  name: "Page404Mobile",
  emits: [...pageNotFoundEmits()],
  setup(props, context) {
    const { doMyShoppingLink, coursesListLink, showShops } =
      usePageNotFound(context);

    const { $showAuth } = useNuxtApp();

    const redirectToLdc = () => {
      $showAuth(() => {
        navigateToInternal(coursesListLink);
      });
    };

    return {
      doMyShoppingLink,
      coursesListLink,
      showShops,
      page404Animation,
      panneauCora,
      redirectToLdc
    };
  }
};
</script>

<template>
  <div class="u-bgcolor-white">
    <Container>
      <div class="u-flex u-flex-justify-center u-mb-xlg">
        <LazyImage
          :src="panneauCora"
          alt=""
          width="100"
          height="73"
        />
      </div>
      <div class="u-flex u-flex-column u-mb-md">
        <LazyImage
          :src="page404Animation"
          alt=""
          width="380"
          height="190"
          class="u-mb-md"
        />
        <div class="u-text-center">
          <p class="u-font-30 u-font-secondary u-color-primary u-font-700">
            Erreur 404
          </p>
          <p class="u-font-24 u-font-secondary u-color-primary u-font-700 u-mb-xs">
            On dirait que cette page s’est égarée…
          </p>
          <p class="u-font-15 u-color-grey-1">
            La page que vous cherchez n’existe plus ou n’a jamais existé.
            Pas de panique, on vous aide à retrouver votre chemin :
          </p>
        </div>
      </div>
      <div class="u-flex u-flex-column u-flex-align-center">
        <ButtonIcon
          icon-name="basket"
          variant="secondary"
          icon-color="white"
          radius="full"
          size="md"
          class="u-mb-md"
          :to="doMyShoppingLink"
        >
          Faire mes courses
        </ButtonIcon>
        <ButtonIcon
          icon-name="mes-listes"
          variant="primary"
          icon-color="white"
          radius="full"
          size="md"
          class="u-mb-md"
          @click="redirectToLdc()"
        >
          Consulter mes listes
        </ButtonIcon>
        <ButtonIcon
          icon-name="shop"
          variant="primary"
          icon-color="white"
          radius="full"
          size="md"
          class="u-mb-md"
          @click="showShops"
        >
          Voir les magasins
        </ButtonIcon>
      </div>
    </Container>
  </div>
</template>

<style lang="scss" scoped>
</style>
